import React, { Suspense } from "react";
import Link from "next/link";
import { toPairs } from "ramda";
import { encode } from "app/(jobs-hiring)/[lang]/jobs-hiring-old/interpreters/encoder";
import AnalyticsLink from "./AnalyticsLink";
import classNames from "classnames";
import ScrollText from "app/components/scrollText";

import styles from "./SimilarJobs.pc.module.scss";
import { setJobViewCookiesTracker, viewJobSourceTracker } from "components/ReportTracker/util";
import { setCookie } from "helpers/cookies";

type propsType = {
  data: any;
  lang: string;
};

const handleToHomePage = (data) => {
  const searchQuery: any = {
    mainFunctions: [data?.main_function],
    jobFunctions: [data?.sub_function],
    workExperience: [data?.xp_lvl_seo_value]
  };

  if (data?.location_seo_value) {
    searchQuery.location = [data?.location_seo_value];
  }

  const result = encode(searchQuery);
  const url = new URLSearchParams(toPairs(result.params)).toString();
  return ("/jobs-hiring/" + result.searchQuery + "?" + url) as string;
};

export default function SimilarJobs({ lang, data }: propsType) {
  const list = data?.similar_job_info ?? [];
  if (list?.length) {
    return (
      <div className={styles.similarJobs}>
        <div className={styles.caption}>
          <h3>{data.title}</h3>
          <Suspense>
            <Link scroll={true} href={handleToHomePage(data.more)}>
              {data.more.text}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
              >
                <path
                  d='M4.66699 11.3334L11.3337 4.66669M11.3337 4.66669H4.66699M11.3337 4.66669V11.3334'
                  stroke='black'
                  strokeWidth='1.33333'
                  strokeLinecap='round'
                  strokeLinejoin='round'
                />
              </svg>
            </Link>
          </Suspense>
        </div>
        <div className={styles.list}>
          <ul>
            {list.map((item, i) => {
              return (
                <AnalyticsLink key={item.job_id} href={null} data={item}>
                  <a
                    href={"/" + lang + item.job_url}
                    target='_blank'
                    onClick={(e) => {
                      e.preventDefault();
                      setJobViewCookiesTracker(setCookie, {
                        source: viewJobSourceTracker.similarJobList,
                        reco_from: item?.reco_from || null,
                        query_id: item?.query_id || null
                      });
                      window.open("/" + lang + item.job_url, "_blank");
                    }}
                  >
                    <li>
                      <div className={styles.left}>
                        <div className={styles.titleContent}>
                          {/* <ScrollText className={styles.title}>{`${item.job_title}`}</ScrollText> */}
                          {/* {item.is_urgent ? (
                            <span className={styles.urgent}>{item.urgent_text}</span>
                          ) : null} */}
                          <div className={styles.title}>
                            <p>
                              <span className={styles.text}>{item.job_title}</span>
                              {item.is_urgent ? (
                                <span className={styles.urgent}>
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='12'
                                    height='12'
                                    viewBox='0 0 12 12'
                                    fill='none'
                                    className={styles.svg}
                                  >
                                    <path
                                      d='M8.56256 1.50055H4.95552C4.78785 1.50055 4.6359 1.5993 4.5678 1.75252L2.33392 6.77874C2.20922 7.05932 2.4146 7.37536 2.72164 7.37536H5.00616L3.8896 11.2833C3.84091 11.4537 4.05318 11.5753 4.17555 11.4471L9.86994 5.48159C10.1277 5.21158 9.93629 4.76433 9.56303 4.76433H7.61719L8.94206 2.11459C9.08312 1.83248 8.87797 1.50055 8.56256 1.50055Z'
                                      fill='black'
                                    />
                                  </svg>
                                  {item.urgent_text}
                                </span>
                              ) : null}
                            </p>
                          </div>
                        </div>
                        <p className={styles.company}>
                          <img src={item.company_logo} alt='' />
                          <span>{item.company_name}</span>
                        </p>
                        <div className={styles.jobTag}>
                          <p className={styles.salary}>
                            <span className={styles.salaryMount}>{item.salary_info.text}</span>
                            {item.salary_info.type_text ? (
                              <span className={styles.salaryType}>
                                [{item.salary_info.type_text}]
                              </span>
                            ) : null}
                          </p>

                          <p className={styles.jobTagContent}>
                            <svg
                              xmlns='http://www.w3.org/2000/svg'
                              width='2'
                              height='2'
                              viewBox='0 0 2 2'
                              fill='none'
                              style={{
                                marginLeft: 7
                              }}
                            >
                              <circle cx='0.75' cy='1' r='0.75' fill='#7D7D7D' />
                            </svg>
                            {item.location ? (
                              <>
                                <span
                                // className={classNames({
                                //   [styles.remote]: item.is_remote_job
                                // })}
                                >
                                  {item.location}
                                </span>
                                <svg
                                  xmlns='http://www.w3.org/2000/svg'
                                  width='2'
                                  height='2'
                                  viewBox='0 0 2 2'
                                  fill='none'
                                >
                                  <circle cx='0.75' cy='1' r='0.75' fill='#7D7D7D' />
                                </svg>
                              </>
                            ) : null}
                            {item.job_tags.map((el, idx, list) => {
                              if (idx === list.length - 1) {
                                return <span key={idx}>{el}</span>;
                              }
                              return (
                                <React.Fragment key={idx}>
                                  <span>{el}</span>
                                  <svg
                                    xmlns='http://www.w3.org/2000/svg'
                                    width='2'
                                    height='2'
                                    viewBox='0 0 2 2'
                                    fill='none'
                                  >
                                    <circle cx='0.75' cy='1' r='0.75' fill='#7D7D7D' />
                                  </svg>
                                </React.Fragment>
                              );
                            })}
                          </p>
                        </div>
                      </div>
                      <div className={styles.right}>
                        <div className={styles.recruiter}>
                          <div className={styles.avatar}>
                            {item.is_online ? <span className={styles.circle}></span> : null}
                            <img src={item.recruiter.avatar} alt={item.full_name} />
                          </div>
                          <p className={styles.recruiterInfo}>
                            <span>{item.recruiter.full_name}</span>
                            <span className={styles.jobTitle}>{item.recruiter.job_title}</span>
                          </p>
                        </div>
                      </div>
                    </li>
                  </a>
                </AnalyticsLink>
              );
            })}
          </ul>
        </div>
      </div>
    );
  }
  return null;
}
